"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundsObserver = void 0;
var react_1 = __importDefault(require("react"));
var bounding_client_rect_observer_1 = require("@html-ng/bounding-client-rect-observer");
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var BoundsObserver = exports.BoundsObserver = /** @class */ (function (_super) {
    __extends(BoundsObserver, _super);
    function BoundsObserver(props) {
        var _this = _super.call(this, props) || this;
        _this._childRef = react_1.default.createRef();
        _this._childNode = null;
        _this._observer = null;
        return _this;
    }
    BoundsObserver.prototype.componentDidMount = function () {
        var childRef = this._childRef.current;
        if (!childRef) {
            throw new Error("Reference should have been set by the time the component is mounted");
        }
        var childNode = react_dom_1.default.findDOMNode(childRef);
        if (!(childNode instanceof Element)) {
            throw new Error("Child's corresponding DOM node should be an Element");
        }
        this._childNode = childNode;
        this._observer = this._observe({
            root: childNode,
            activate: this.props.enabled,
        });
    };
    BoundsObserver.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _this = this;
        var oldObserver = this._observer;
        if (!oldObserver) {
            throw new Error("Observer should have been installed by the time the component is updated");
        }
        var childNode = this._childNode;
        if (!childNode) {
            throw new Error("Reference should have been set by the time the component is updated");
        }
        /**
         * Handle the potential change of callbacks
         *
         * @returns The new current bounds observer
         */
        var handleCallbackUpdate = function () {
            if (_this.props.onBoundsChange != prevProps.onBoundsChange) {
                oldObserver.disconnect();
                var newObserver = _this._observe({
                    root: childNode,
                    // Ensure that the new observer is active, if the previous one was
                    activate: prevProps.enabled,
                });
                _this._observer = newObserver;
                return newObserver;
            }
            else {
                return oldObserver;
            }
        };
        var currentObserver = handleCallbackUpdate();
        if (this.props.enabled != prevProps.enabled) {
            if (this.props.enabled) {
                this._activate({ observer: currentObserver, root: childNode });
            }
            else {
                this._deactivate({ observer: currentObserver });
            }
        }
    };
    BoundsObserver.prototype.componentWillUnmount = function () {
        var observer = this._observer;
        if (!observer) {
            throw new Error("Observer should have been installed by the time the component is unmounted");
        }
        this._deactivate({ observer: observer });
    };
    BoundsObserver.prototype.render = function () {
        var child = react_1.default.Children.only(this.props.children);
        return react_1.default.cloneElement(child, {
            ref: this._childRef
        });
    };
    BoundsObserver.prototype._observe = function (args) {
        var _this = this;
        var root = args.root, activate = args.activate;
        var observer = new bounding_client_rect_observer_1.BoundingClientRectObserver(function (entries) {
            // In practice, in our case there should always be one entry, and the target should be root
            entries.forEach(function (entry) {
                if (entry.target === root) {
                    _this.props.onBoundsChange(entries[0].newBounds);
                }
            });
        });
        if (activate) {
            this._activate({ observer: observer, root: root });
        }
        return observer;
    };
    BoundsObserver.prototype._activate = function (args) {
        var observer = args.observer, root = args.root;
        observer.observe(root);
        var initialBounds = root.getBoundingClientRect();
        this.props.onBoundsChange(initialBounds);
    };
    BoundsObserver.prototype._deactivate = function (args) {
        var observer = args.observer;
        observer.disconnect();
    };
    BoundsObserver.propTypes = {
        children: prop_types_1.default.element.isRequired,
    };
    return BoundsObserver;
}(react_1.default.Component));
//# sourceMappingURL=index.js.map